import { useNavigate } from "react-router-dom";
import { Icon } from "@/components/primitives";
import { MobileFrame } from "@/components/MobileFrame";
import { useTierFeatures } from "@/hooks/useTierFeatures";

export default function PostChoice() {
  const nav = useNavigate();
  const { features } = useTierFeatures();

  return (
    <MobileFrame>
      <div style={{ minHeight: "100vh", background: "hsl(var(--paper))", display: "flex", flexDirection: "column", paddingBottom: 40 }}>
        {/* Top bar */}
        <div style={{ padding: "12px 20px 0", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <button
            onClick={() => nav(-1)}
            aria-label="Close"
            style={{
              width: 40, height: 40, border: "1px solid hsl(var(--ink))",
              background: "hsl(var(--paper))", color: "hsl(var(--ink))", cursor: "pointer",
              display: "flex", alignItems: "center", justifyContent: "center",
            }}
          >
            {Icon.x(18)}
          </button>
          <div style={{ textAlign: "center", color: "hsl(var(--ink))" }}>
            <div className="caps" style={{ color: "hsl(var(--rust))" }}>New post</div>
            <div style={{ fontFamily: "'Fraunces', 'Playfair Display', serif", fontWeight: 700, fontSize: 18 }}>How are we posting?</div>
          </div>
          <div style={{ width: 40, height: 40 }} />
        </div>

        <div style={{ padding: "28px 20px 0", display: "flex", flexDirection: "column", gap: 14 }}>
          {/* Quick Thrift — Lens-class in-store buy-decision tool */}
          <button
            onClick={() => nav("/scan/quick")}
            style={{
              textAlign: "left", padding: "18px 18px 20px",
              background: "hsl(var(--cream))", color: "hsl(var(--ink))",
              border: "1px solid hsl(var(--ink))",
              cursor: "pointer",
              display: "flex", flexDirection: "column", gap: 8,
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
              <span className="caps" style={{
                background: "hsl(var(--ink))", color: "hsl(var(--ink-fg))",
                padding: "3px 7px", fontSize: 9, letterSpacing: "0.1em",
              }}>Quick thrift</span>
              <span className="caps" style={{ fontSize: 9, color: "hsl(var(--ink-2))", letterSpacing: "0.12em" }}>~3 sec · free</span>
            </div>
            <div style={{ fontFamily: "'Fraunces', 'Playfair Display', serif", fontWeight: 700, fontSize: 20 }}>
              Quick thrift read
            </div>
            <div style={{ fontFamily: "'Fraunces', 'Playfair Display', serif", fontSize: 13, lineHeight: 1.4, color: "hsl(var(--ink-2))" }}>
              One photo — brand, era, and a rough price range. Use this in the rack to decide whether to buy.
            </div>
          </button>

          {/* Verify now */}
          <button
            onClick={() => nav("/scan")}
            style={{
              textAlign: "left", padding: "18px 18px 20px",
              background: "hsl(var(--ink))", color: "hsl(var(--cream))",
              border: "1px solid hsl(var(--ink))",
              cursor: "pointer",
              display: "flex", flexDirection: "column", gap: 8,
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
              <span className="caps" style={{
                background: "hsl(var(--rust))", color: "hsl(var(--rust-fg))",
                padding: "3px 7px", fontSize: 9, letterSpacing: "0.1em",
              }}>FIG verified</span>
              <span className="caps" style={{ fontSize: 9, color: "hsl(var(--ink-fg))", letterSpacing: "0.12em" }}>~60 sec</span>
            </div>
            <div style={{ fontFamily: "'Fraunces', 'Playfair Display', serif", fontWeight: 700, fontSize: 20 }}>
              Verify now
            </div>
            <div style={{ fontFamily: "'Fraunces', 'Playfair Display', serif", fontSize: 13, lineHeight: 1.4, opacity: 0.9 }}>
              {"Run the full FIG Verify pipeline. Fig reads every photo, identifies the piece, prices it, and earns the verified badge before posting."}
            </div>
          </button>

          {/* Skip — quick post */}
          <button
            onClick={() => nav("/post/quick")}
            style={{
              textAlign: "left", padding: "18px 18px 20px",
              background: "hsl(var(--cream))", color: "hsl(var(--ink))",
              border: "1px solid hsl(var(--ink))", cursor: "pointer",
              display: "flex", flexDirection: "column", gap: 8,
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
              <span className="caps" style={{
                background: "hsl(var(--paper))", color: "hsl(var(--ink))",
                padding: "3px 7px", fontSize: 9, letterSpacing: "0.1em",
                border: "1px solid hsl(var(--ink))",
              }}>Quick post</span>
              <span className="caps" style={{ fontSize: 9, color: "hsl(var(--ink-2))", letterSpacing: "0.12em" }}>Share as find</span>
            </div>
            <div style={{ fontFamily: "'Fraunces', 'Playfair Display', serif", fontWeight: 700, fontSize: 20 }}>
              Skip — just post it
            </div>
            <div style={{ fontFamily: "'Fraunces', 'Playfair Display', serif", fontSize: 13, lineHeight: 1.4, color: "hsl(var(--ink-2))" }}>
              Upload photos, write a caption, add where it's listed (or kept) and go. No verification, no verified badge.
            </div>
          </button>

          {/* Bulk verify — Pro Seller only. Independent flow that queues
              up to 50 items in the background; doesn't share state with the
              single-item Verify-now path above. */}
          {features.canBulkUpload && (
            <button
              onClick={() => nav("/bulk")}
              style={{
                textAlign: "left", padding: "18px 18px 20px",
                background: "hsl(var(--ink))", color: "hsl(var(--cream))",
                border: "1px solid hsl(var(--marigold))", cursor: "pointer",
                display: "flex", flexDirection: "column", gap: 8,
              }}
            >
              <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                <span className="caps" style={{
                  background: "hsl(var(--marigold))", color: "hsl(var(--marigold-fg))",
                  padding: "3px 7px", fontSize: 9, letterSpacing: "0.1em",
                }}>Pro · Bulk</span>
                <span className="caps" style={{ fontSize: 9, color: "hsl(var(--ink-fg))", letterSpacing: "0.12em" }}>Up to 50 items</span>
              </div>
              <div style={{ fontFamily: "'Fraunces', 'Playfair Display', serif", fontWeight: 700, fontSize: 20 }}>
                Bulk verify
              </div>
              <div style={{ fontFamily: "'Fraunces', 'Playfair Display', serif", fontSize: 13, lineHeight: 1.4, opacity: 0.85 }}>
                Queue a whole batch. Fig verifies them in the background — leave the screen, come back, review the results when they're ready.
              </div>
            </button>
          )}

          <p style={{
            marginTop: 4, fontFamily: "'IBM Plex Mono', monospace",
            fontSize: 10, letterSpacing: "0.05em", color: "hsl(var(--ink-2))",
            lineHeight: 1.5, padding: "0 4px",
          }}>
            You can run verification later from the post itself — tap "Verify this post" under your unverified posts.
          </p>
        </div>
      </div>
    </MobileFrame>
  );
}